// extracted by mini-css-extract-plugin
export default {"wrapper_header":"Sending_wrapper_header__Nitao","wrapper_title":"Sending_wrapper_title__9nRLj","wrapper_subtitle":"Sending_wrapper_subtitle__fW09I"};